<template>
  <div :class="cardClass">
    <div class="header">
      <div class="full-width">
        <h2 class="title">Calls By Day of Week</h2>
      </div>
    </div>
    <div class="root">
      <div v-if="weekDays">
        <bar-chart
          class="print-hide"
          :data="weekDays"
          :dataset="{ borderWidth: 0 }"
          :download="false"
          :colors="['rgba(64, 121, 157, 1)']"
          height="250px"
          width="100%"
          :library="chartOptions"
        />
        <ul class="print-data-list cells print-only-inline">
          <li v-for="(v, k) in weekDays" :key="k">
            {{ k }} <strong>{{ v }}%</strong>
            <span class="bar-container">
              <span class="bar" :style="{ width: (100 * v) / 100 }"></span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import Vue from 'vue';
import Chartkick from 'vue-chartkick';

Vue.use(Chartkick.use(Chart));

export default {
    name: 'CrisisCallsByDayOfWeek',
    props: {
        data: {
            type: Object,
            default: () => null
        },
        loading: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            chartOptions: {
                animation: {
                    easing: 'easeOutQuad',
                    duration: 300
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                scales: {
                    yAxes: [
                        {
                            gridLines: { display: false },
                            ticks: { fontSize: 15, fontColor: '#ffffff' }
                        }
                    ],
                    xAxes: [
                        {
                            gridLines: {
                                display: false,
                            },
                            ticks: {
                                fontSize: 15,
                                fontColor: '#ffffff',
                                callback(value) {
                                    return `${value}`;
                                },
                                precision: 0,
                            }
                        }
                    ]
                },
                tooltips: {
                    enabled: true,
                    callbacks: {
                        label: ({ value }) => `${value}`
                    }
                }
            }
        }
    },
    computed: {
        cardClass() {
            if (this.loading) return 'dashboard-card chart-card skeleton progress';
            if (!this.weekDays) return 'dashboard-card chart-card no-data';
            return 'dashboard-card chart-card';
        },
        weekDays() {
            if (Object.keys(this.data).length === 0) {
                return false;
            }
            const orderOfDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
            const sortedDays = orderOfDays.reduce((sortedObj, day) => {
                if (this.data[day] !== undefined) {
                    sortedObj[day] = this.data[day];
                }
                return sortedObj;
            }, {});

        return sortedDays;
        }
    }
}
</script>

<style lang="scss" scoped>
.chart-card {
    width: 100%;
    padding: 0;

    &.no-data {
        opacity: 0.5;
    }

    .header {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-content: stretch;
        margin-bottom: 1rem;
        padding: 1.5rem 1.25rem 0 1.24rem;

        .title {
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0.01rem;
            margin: 0 0 0.75rem 0;
            text-transform: none;
        }
    }
    .root {
        padding: 0 2.45rem;
        height: 260px;
    }
}
</style>
